import ApiService from '@/core/services/api.service';
import { formatDate, unMaskPrice } from '@/utils/common';

/**
 * Service for handling approval info-related API calls
 */
export default {
  /**
   * Get approval by ID
   * @param {string|number} id - Approval ID
   * @returns {Promise} - Promise with the approval data
   */
  getApprovalById(id) {
    return ApiService.get(`v1/approvals/${id}`)
      .then((response) => response.data.data)
      .catch((error) => {
        console.error('Error fetching approval details:', error);
        throw error;
      });
  },

  /**
   * Create a new approval
   * @param {Object} payload - Approval data
   * @returns {Promise} - Promise with the response data
   */
  createApproval(payload) {
    return ApiService.post('v1/approvals', this.preparePayload(payload))
      .then((response) => response.data)
      .catch((error) => {
        console.error('Error creating approval:', error);
        throw error;
      });
  },

  /**
   * Update an existing approval
   * @param {Object} payload - Approval data
   * @returns {Promise} - Promise with the response data
   */
  updateApproval(payload) {
    return ApiService.put('v1/approvals', this.preparePayload(payload))
      .then((response) => response.data)
      .catch((error) => {
        console.error('Error updating approval:', error);
        throw error;
      });
  },

  /**
   * Get customer by phone number
   * @param {string} phoneNumber - Customer phone number
   * @returns {Promise} - Promise with the customer data
   */
  getCustomerByPhone(phoneNumber) {
    return ApiService.get(`/v1/customers/get-by-phone?phoneNumber=${phoneNumber}`)
      .then((response) => response.data.data)
      .catch((error) => {
        console.error('Error fetching customer by phone:', error);
        throw error;
      });
  },

  /**
   * Prepare payload for API request
   * @param {Object} data - Form data
   * @returns {Object} - Prepared payload
   * @private
   */
  preparePayload(data) {
    return {
      ...data,
      amount: unMaskPrice(data.amount),
      vatAmount: unMaskPrice(data.vatAmount),
      paymentDate: formatDate(data.paymentDate, 'yyyy-MM-DD'),
    };
  },

  /**
   * Save approval (create or update)
   * @param {Object} payload - Approval data
   * @returns {Promise} - Promise with the response data
   */
  saveApproval(payload) {
    if (!payload.id) {
      return this.createApproval(payload);
    }
    return this.updateApproval(payload);
  },
};
